import React from 'react'
import { useState } from "react";
import { FaArrowAltCircleUp } from "react-icons/fa";
import facebook from '../images/facebook.png';
import twitter from '../images/twitter.png';
import instagram from '../images/instagram.png';
import pinterest from '../images/pinterest.png';
import youtube from '../images/youtube.png';
import linkedin from '../images/linkedin.png';
import { FaBars } from "react-icons/fa";

export default function Footer() {
  return (
    <>
      <footer>
        <div className="container">
          <div className="rd-socal-icon">
           <a href="#" target="_blank" aria-label="Facebook">
            <img src={facebook} width="32" height="32" alt="Facebook" title="Facebook" />
            </a>
           <a href="https://x.com/riyadubeyes/" target="_blank" aria-label="Twitter">
           <img src={twitter} width="32" height="32" alt="Twitter" title="Twitter" />
           </a>
           <a href="https://www.instagram.com/riyadubeyes/" target="_blank" aria-label="Instagram">
           <img src={instagram} width="32" height="32" alt="Instagram" title="Instagram" />
           </a>
           <a href="https://www.pinterest.com/riyadubeyes/" target="_blank" aria-label="Pinterest">
           <img src={pinterest} width="32" height="32" alt="Pinterest" title="Pinterest" />
           </a>
           <a href="https://www.linkedin.com/in/riyadubeyes/" target="_blank" aria-label="Linkedin">
           <img src={linkedin} width="32" height="32" alt="Linkedin" title="Linkedin" />
           </a>
           <a href="https://www.youtube.com/@riyadubeyes" target="_blank" aria-label="Youtube">
           <img src={youtube} width="32" height="32" alt="Youtube" title="Youtube" />
           </a>
          </div>
         <h6>Disclaimer</h6>
         <p>This website is strictly for adults aged 18 years and above. All content published here is meant solely for entertainment and promotional purposes. We do not encourage or support any form of illegal activity. Images, profiles, and information shown on this site are illustrative only and may not reflect real individuals or services. By accessing this website, you confirm that you are 18+ and accept all applicable terms.</p>
         <p>Copyright © 2025 <a href="https://www.riyadubey.com/"><strong>Riya Dubey</strong></a> - Gurgaon Escorts</p>
        </div>
      </footer>
      <div className="rd-scrol">
        <a href="#up-click" aria-label="Click To Scroll">
          <FaArrowAltCircleUp />
        </a>
      </div>
    </>
  )
}
